import { Link } from "react-router-dom";
import { Lock, Zap, Crown } from "lucide-react";

export function LockedFeature({ title, description, perks = [] }) {
  return (
    <div className="eco-card p-8 md:p-12 text-center max-w-2xl mx-auto" data-testid="locked-feature">
      <div className="h-16 w-16 rounded-2xl bg-amber-400/10 border border-amber-400/20 flex items-center justify-center mx-auto mb-6">
        <Lock size={28} className="text-amber-400" strokeWidth={1.5} />
      </div>
      <span className="eco-tag inline-flex items-center gap-1.5 text-amber-300 border-amber-400/20 bg-amber-400/10 mb-4"><Crown size={13} /> ECO PRO</span>
      <h2 className="font-display text-2xl md:text-3xl font-semibold text-white mb-3">{title}</h2>
      <p className="text-slate-400 mb-6 max-w-md mx-auto">{description}</p>
      {perks.length > 0 && (
        <ul className="text-left max-w-sm mx-auto space-y-2 mb-8">
          {perks.map((p) => (
            <li key={p} className="flex items-center gap-3 text-sm text-slate-300">
              <span className="h-1.5 w-1.5 rounded-full bg-[#0055FF]" /> {p}
            </li>
          ))}
        </ul>
      )}
      <Link to="/pricing" data-testid="locked-upgrade-btn" className="btn-accent"><Zap size={16} /> Unlock with Pro</Link>
    </div>
  );
}
